import { render, staticRenderFns } from "./RankNew.vue?vue&type=template&id=ba0c1714"
import script from "./RankNew.vue?vue&type=script&lang=js"
export * from "./RankNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports